import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";

export const Info = () => {
  const SUBSCRIPTION_KNOWLEDGE_BASE_URL =
    "https://community.circle.so/c/paywalls/";
  return (
    <div className="border-primary mb-4 mt-0 rounded-lg border p-4">
      <div className="mr-5 flex justify-around gap-4">
        <div>
          <Icon type="sw-question" className="text-dark" />
        </div>
        <div>
          <h4>{t("settings.paywall_groups.headings.what_is")}</h4>
          <p className="text-dark text-sm">
            {t("settings.paywall_groups.alerts.info.what_is")}
            &nbsp;
            {/* TODO: redirect to knowledge base article once Peter creates it  */}
            <a
              href={SUBSCRIPTION_KNOWLEDGE_BASE_URL}
              target="_blank"
              rel="noreferrer"
            >
              {t("settings.paywall_groups.actions.learn_more")}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};
